import { ActionTypes } from "@/App/constants/actionTypes";
import { PricingLevelsTypes } from "@/types";

type UpdatePricingLevelAction = {
  type: typeof ActionTypes.UPDATE_PRICING_LEVEL;
  payload: {
    data: PricingLevelsTypes.PricingLevel;
    formName: string;
  };
};

export const updatePricingLevel = (data: {
  data: PricingLevelsTypes.PricingLevel;
  formName: string;
}): UpdatePricingLevelAction => {
  return {
    type: ActionTypes.UPDATE_PRICING_LEVEL,
    payload: data,
  };
};

type UpdatePricingLevelResultAction = {
  type: typeof ActionTypes.UPDATE_PRICING_LEVEL_RESULTS;
  payload: PricingLevelsTypes.PricingLevel;
};

export const updatePricingLevelResult = (
  data: PricingLevelsTypes.PricingLevel,
): UpdatePricingLevelResultAction => {
  return {
    type: ActionTypes.UPDATE_PRICING_LEVEL_RESULTS,
    payload: data,
  };
};

export type UpdatePricingLevelActions = UpdatePricingLevelAction | UpdatePricingLevelResultAction;
